var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 7,
    height: 7,
    rx: 1,
    stroke: "#9090AB",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 3,
    height: 3,
    fill: "#9090AB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 7,
    height: 7,
    rx: 1,
    stroke: "#9090AB",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 3,
    height: 3,
    fill: "#9090AB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 7,
    height: 7,
    rx: 1,
    stroke: "#9090AB",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 3,
    height: 3,
    fill: "#9090AB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 3,
    height: 3,
    fill: "#9090AB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 3,
    height: 3,
    fill: "#9090AB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 3,
    height: 3,
    fill: "#9090AB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 3,
    height: 3,
    fill: "#9090AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QrCode.d4de4e5110eb2ccb9747b146208b5142.svg";
export { ForwardRef as ReactComponent };